export enum QueryParamKeys {
  SEARCH = "search",
  CATEGORY = "category",
}
